// extracted by mini-css-extract-plugin
module.exports = {"label":"label__1KB72","automateSpan":"automateSpan__3mdX8","link":"link__18NMD","icon":"icon__1tWCH","avatar":"avatar__1H-qf"};